module.exports = __webpack_public_path__ + "static/fx_10.495e0e90.jpg";